import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgGovernmentSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3.25a.75.75 0 00-.75.75v.077c0 .941 0 2.043.289 2.91.155.467.411.925.844 1.261.44.342.987.502 1.617.502h.25V21c0 .414.336.75.75.75h12a.75.75 0 00.75-.75V8.75H19c.63 0 1.177-.16 1.617-.502.433-.336.689-.794.845-1.26.288-.868.288-1.97.288-2.911V4a.75.75 0 00-.75-.75H3zM17.25 8a.75.75 0 00-.75-.75h-9a.75.75 0 000 1.5h9a.75.75 0 00.75-.75zm-2.5 12.25h-1.5V16a.75.75 0 011.5 0v4.25zm-4 0V16a.75.75 0 00-1.5 0v4.25h1.5zm-4-8.25a.75.75 0 01.75-.75h9a.75.75 0 010 1.5h-9a.75.75 0 01-.75-.75z",
    fill: "currentColor"
  })));
}

export { SvgGovernmentSolid as ReactComponent };
